define("lib/kryptonite", ["jquery"], function ($) {
  $.kryptonite = function (url, opt) {
    options = (typeof opt === "object") ? opt : {};
    if (typeof opt === "function") {
      options.success = opt;
    }
    if (typeof url === "string") {
      options.url = url;
    } else {
      options = url;
    }
    options.dataType = "kryptonite";
    return $.ajax(options);
  };
  
  $.kryptonite.uncomment = function (string) {
    return string.replace(/^\s*<!--/, '').replace(/(-->\s*$)/, '');
  };
  
  $.kryptonite.handle = function (response) {
    // adding html5 tag support for older browsers
    if (typeof window.innerShiv === 'function') {
      response = window.innerShiv(response, false, false);
    }
    var $els = $(response);
    $els.filter('[data-selector]').each(function (i, el) {
      try {
        var $el = $(el);
        var selector = $el.attr('data-selector');
        var action = $el.attr('data-action') || $.kryptonite.options.defaultAction;
        if ($.kryptonite.options.alias[action] !== undefined) {
          action = $.kryptonite.options.alias[action];
        }
        var content = $.kryptonite.uncomment($el.html());
        //console.log(selector, action, content);
        $(selector)[action](content);
      } catch (e) {
        console.log(e);
      }
    });
    $els.filter('[data-eval]').each(function (i, el) {
      var script = $(el).data('eval');
      script = script.replace("quot;", '\"');
      $.globalEval(script);
    });
    //- Start ADDED BY neuland
    $els.filter('script').each(function (i, $el) {
      $("body").append($el);
    });
    //- End
    return response;
  };
  
  $.kryptonite.options = {
    alias: {
      'replace': 'replaceWith',
      'replaceContent': 'html'
    },
    defaultAction: 'replaceContent'
  };
  

  $.ajaxSetup({
    converters: {
      "text kryptonite": $.kryptonite.handle
    }
  });
});